import React, { useState, useEffect } from 'react';
import { Provider, useSelector } from 'react-redux';
import intl from 'react-intl-universal';
import { setDefaultConfig, ConfigProvider } from 'antd-mobile';
// import { setRootFontSize, debounce } from './utils/responsive';
import { selectTheme } from './store/reducers/theme';

import enUS from 'antd-mobile/es/locales/en-US';
import zhCN from 'antd-mobile/es/locales/zh-CN';
import thTH from 'antd-mobile/es/locales/th-TH';

import Router from './router';
import store from './store';
import { getCurrLang, loadLocale } from "./locales";
import GlobalChatbot from './components/GlobalChatbot'

import { initGlobalClickTimeoutCheck, removeGlobalClickTimeoutCheck } from './utils/timeoutHandle';
import { setMysteryCode, getMysteryCode } from './utils/session/store'
import { getUrlParam } from './utils'

import './assets/styles/index.less';
import './assets/styles/theme.less';

const lanSet = {
  zh: zhCN,
  en: enUS,
  th: thTH,
}

// 初始化 antd-mobile 的默认配置
const currentLanKey = getCurrLang();
const currentLanObj = lanSet[currentLanKey] || enUS;
setDefaultConfig({ locale: currentLanObj });

const Root = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};

const App = () => {
  const [initDone, setInitDone] = useState(false);
  const [lanObj, setLanObj] = useState(currentLanObj);
  const [lanKey, setLanKey] = useState(currentLanKey);

  const themeId = useSelector(selectTheme);
  console.log('======/////=====')
  useEffect(() => {
    console.log('themeId', themeId);
  }, [themeId]);

  useEffect(() => {
    let cancelled = false

    // 只初始化当前语言，避免把全部语言包打进首屏
    loadLocale(currentLanKey)
      .then(({ locale, messages }) => intl.init({
        currentLocale: locale,
        locales: { [locale]: messages },
      }))
      .then(() => {
        if (!cancelled) setInitDone(true)
      })
      .catch((err) => {
        console.log(err)
        if (!cancelled) setInitDone(true)
      })

    const urlCodeTime = getUrlParam('mysterycode') || getMysteryCode()
    setMysteryCode(urlCodeTime)
    // 启用全局点击事件超时检测
    initGlobalClickTimeoutCheck();

    // 组件卸载时清理
    return () => {
      cancelled = true
      removeGlobalClickTimeoutCheck();
    };

  }, []);

  /*
  useEffect(() => {
    // 初始化字体大小
    setRootFontSize();
    
    // 监听窗口大小变化
    const handleResize = debounce(setRootFontSize, 100);
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  */

  //检测页面操作是否过期
  // useEffect(() => {
  //   const urlCodeTime = getUrlParam('mysterycode') || getMysteryCode()
  //   setMysteryCode(urlCodeTime)
  //   if (urlCodeTime) {
  //     initWatchTimeout()
  //   }
  // }, []);

  if (!initDone) {
    return null;
  }

  return (
    <ConfigProvider locale={lanObj}>
      <Router />
      <GlobalChatbot />
    </ConfigProvider>
  );
};

export default Root;
